import axios from '@axios'

/**
 * ÍNDICE
 * {@link getProducts} - Obtener productos
 * {@link getProduct} - Obtener producto
 * {@link addProduct} - Agregar producto
 * {@link deleteProduct} - Eliminar producto
 * {@link updateProduct} - Actualizar producto
 * {@link downloadProducts} - Descargar productos
 */

/**
 * 
 * @param {*} queryParams 
 * @returns products
 */

export const getProducts = function (queryParams) {
    return new Promise((resolve, reject) => {
        axios
            .get('/products', {params: queryParams })
            .then(response => resolve(response))
            .catch(error => reject(error))
    })
}
export const getProduct = function ({ id }) {
    return new  Promise((resolve, reject) => {
        axios
            .get(`/products/${id}`)
            .then(response => resolve(response))
            .catch(error => reject(error))
    })
}

export const addProduct = function (data) {
    return new Promise((resolve, reject) => {
        axios
            .post('/products', data)
            .then(response => resolve(response))
            .catch(error => reject(error))
    })
}
export const deleteProduct = function ({ id }) {
    return new Promise((resolve, reject) => {
        axios
            .delete(`/products/${id}`)
            .then(response => resolve(response))
            .catch(error => reject(error))
    })
}
export const updateProduct = function (data) {
    return new Promise((resolve, reject) => {
        axios
            .put(`/products/${data.id}`, data)
            .then(response => resolve(response))
            .catch(error => reject(error)) 
    })
}
export const downloadProducts = function (data)  {
    return new Promise((resolve, reject) => 
    {
        axios
            .post('/download-products',  data,{ responseType: 'arraybuffer' })
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
}
